import css from 'styled-jsx/css';

export default css`.lazy-load-img {
  max-width: 100%;
  overflow: hidden;
  position: relative;
  font-size: 0; }
  .lazy-load-img img,
  .lazy-load-img video,
  .lazy-load-img iframe,
  .lazy-load-img object,
  .lazy-load-img embed {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0; }
  .lazy-load-img img {
    display: block;
    visibility: visible;
    opacity: 1;
    width: 100%;
    max-width: 100%;
    transition: opacity 0.3s; }
  .lazy-load-img.hidden img {
    visibility: hidden;
    opacity: 0.01; }

.post-not-found,
.page-not-found {
  display: block;
  width: 300px;
  height: 300px;
  margin: 0 auto; }
  @media only screen and (max-width: 600px) {
    .post-not-found,
    .page-not-found {
      width: 350px;
      height: 350px; } }
  @media only screen and (min-width: 768px) {
    .post-not-found,
    .page-not-found {
      width: 400px;
      height: 400px; } }
  @media only screen and (min-width: 992px) {
    .post-not-found,
    .page-not-found {
      width: 450px;
      height: 450px; } }
  @media only screen and (min-width: 1200px) {
    .post-not-found,
    .page-not-found {
      width: 500px;
      height: 500px; } }

.userinfo-author-img {
  float: left;
  width: 40px;
  height: 40px;
  border-radius: 50%; }
  .userinfo-author-img.detail {
    margin-right: 10px; }
  .userinfo-author-img.isNotSecret {
    background-image: url("https://static.popdaily.com.tw/img/head2.png") !important;
    background-size: 40px 40px;
    background-position: center;
    background-repeat: no-repeat; }
  .userinfo-author-img img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    margin-top: 0; }

.articleCard-img {
  border-radius: 8px; }

/* circle images */
.articleCard-author-img, .recommended-user-img, .appHeader-user-img, .commend-cube-user-img, .reply-cube-user-img {
  position: relative;
  float: left;
  margin: 0;
  vertical-align: middle;
  border-radius: 50%;
  overflow: hidden; }

.articleCard-author-img {
  width: 18px;
  height: 18px; }

.recommended-user-img {
  width: 35px;
  height: 35px; }

.appHeader-user-img {
  width: 32px;
  height: 32px; }

.commend-cube-user-img {
  width: 30px;
  height: 30px; }

.reply-cube-user-img {
  width: 25px;
  height: 25px; }
`